import { array, bool } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { useSignups } from "Signups/state";

const getFirstName = (name) => {
  return name?.split(" ")[0];
};

export default function CurrentlySignedUpSecondaryTextMemberType({
  respondents,
  needsPayment,
}) {
  const [state] = useSignups();
  const { currentSignupList: { fundIt: { isSuggestedDonation } = {} } = {} } =
    state;
  const hasExistingUnpaidItems =
    state?.currentSignupList?.hasExistingUnpaidItems;

  const allRespondentsPaid = respondents.every(
    (r) =>
      r.paymentStatus.toLowerCase() === "paid" ||
      r.paymentStatus.toLowerCase() === "markedaspaid" ||
      r.paymentStatus.toLowerCase() === "free"
  );

  const names = getRespondentsNamesList(respondents);

  if (allRespondentsPaid || isSuggestedDonation) {
    return <Names $allRespondentsPaid={allRespondentsPaid}>{names}</Names>;
  }

  const getStatusText = (status) => {
    const lstatus = status.toLowerCase();
    if (lstatus === "paid" || lstatus === "markedaspaid") {
      return "Paid";
    }

    return "Unpaid";
  };

  return (
    <UL>
      {respondents.map((r) => {
        const hasNoName = !r.name || r.name.toLowerCase().includes("no name");
        let displayName = hasNoName ? "No name" : getFirstName(r.name);
        const isPaid =
          r.paymentStatus.toLowerCase() === "paid" ||
          r.paymentStatus.toLowerCase() === "markedaspaid";
        const showPill = hasExistingUnpaidItems || isPaid;

        return (
          <LI key={r.ID}>
            {displayName}{" "}
            {showPill ? (
              <Pill $isPaid={isPaid}>{getStatusText(r.paymentStatus)}</Pill>
            ) : null}
          </LI>
        );
      })}
    </UL>
  );
}

CurrentlySignedUpSecondaryTextMemberType.propTypes = {
  respondents: array.isRequired,
  needsPayment: bool.isRequired,
};

const UL = styled.ul`
  padding-inline-start: 1rem;
  margin-block: 0.25rem 0;
`;

const LI = styled.li`
  /* display: grid;
    grid-template-columns: 3.75rem 1fr; */
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:before {
    content: "• ";
  }
`;

const Pill = styled.span`
  background: ${(props) =>
    props.$isPaid
      ? "linear-gradient(145deg, #0dc05a, #01b44f);"
      : "linear-gradient(145deg, #ff6363, #e65454);"};
  border-radius: 20px;
  color: #ffffff;
  font-size: 10px;
  padding: 1px 6px 1px 7px;
  margin-right: 5px;
  text-transform: uppercase;
  height: min-content;
  text-align: center;
  font-weight: 600;
  letter-spacing: 1px;
  transform: translateY(1px);
`;

const Names = styled.span`
  color: ${(props) => (props.$allRespondentsPaid ? "#fff" : "inherit")};
  opacity: ${(props) => (props.$allRespondentsPaid ? 0.75 : 1)};
`;

function getRespondentsNamesList(respondents) {
  let names = ``;
  respondents.forEach((r) => {
    const hasNoName = !r.name || r.name.toLowerCase().includes("no name");
    let displayName = "";
    if (hasNoName) {
      displayName = "No name";
    } else {
      displayName = getFirstName(r.name);
    }
    names += `• ${displayName} `;
  });
  return names;
}